/* Kocktail — review rail.
   Progressive enhancement over a native scroll-snap list: the rail already
   scrolls, snaps, swipes and takes keyboard focus on its own, so this only
   adds the things CSS cannot do — dots, arrows, and a gentle auto-advance.
   If the script never runs, the rail is still fully usable; the controls are
   rendered hidden and only revealed once they are wired up. */
(function () {
  var INTERVAL = 6000;   // ms between auto-advances
  var RESUME = 12000;    // ms of quiet after a manual interaction before resuming

  /* Spotlight: one quote on screen at a time, with the row of source logos
     underneath acting as the navigation. Unlike the rail there is no native
     behaviour to build on — nothing in CSS can show one of N things and cycle
     — so the whole state machine lives here. The markup ships with the first
     quote already active, so a script failure leaves one readable quote and a
     row of logos rather than an empty band. */
  function setupSpotlight(root) {
    var items = root.querySelectorAll('[data-kx-spot-item]');
    var tabs = root.querySelectorAll('[data-kx-spot-tab]');
    var n = items.length;
    if (n < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;
    var idle = null;
    var visible = true;

    function show(i) {
      index = ((i % n) + n) % n;
      for (var k = 0; k < n; k++) {
        var on = k === index;
        items[k].classList.toggle('is-active', on);
        // Keep the hidden quotes out of the accessibility tree as well as out
        // of sight, or a screen reader reads all of them back to back.
        if (on) items[k].removeAttribute('aria-hidden');
        else items[k].setAttribute('aria-hidden', 'true');
        if (tabs[k]) {
          tabs[k].classList.toggle('is-active', on);
          tabs[k].setAttribute('aria-current', on ? 'true' : 'false');
        }
      }
    }

    function start() {
      if (reduce || timer || !visible) return;
      timer = setInterval(function () { show(index + 1); }, INTERVAL);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pause() {
      stop();
      if (idle) clearTimeout(idle);
      idle = setTimeout(start, RESUME);
    }

    for (var i = 0; i < tabs.length; i++) {
      (function (idx) {
        tabs[idx].addEventListener('click', function () { pause(); show(idx); });
      })(i);
    }

    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.2 }).observe(root);
    }

    show(0);
    start();
  }

  function setupRail(root) {
    var rail = root.querySelector('[data-kx-quotes-rail]');
    var dotsBox = root.querySelector('[data-kx-quotes-dots]');
    var prev = root.querySelector('[data-kx-quotes-prev]');
    var next = root.querySelector('[data-kx-quotes-next]');
    if (!rail) return;
    var items = rail.querySelectorAll('[data-kx-quote]');
    var n = items.length;
    if (!n) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var dots = [];
    var index = 0;
    var timer = null;
    var idle = null;
    var visible = true;

    // How far one card sits from the next, including the gap. Read from the
    // laid-out elements rather than assumed, so it stays correct across the
    // breakpoints that change how many cards are on screen.
    function stride() {
      if (n < 2) return rail.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }
    // Scrollable distance. Zero when every card already fits, which is the
    // signal that there is nothing to page through.
    function maxScroll() {
      return rail.scrollWidth - rail.clientWidth;
    }
    function pages() {
      var s = stride();
      return s > 0 ? Math.round(maxScroll() / s) + 1 : 1;
    }

    function goTo(i, smooth) {
      var s = stride();
      var left = Math.min(i * s, maxScroll());
      if (rail.scrollTo) {
        rail.scrollTo({ left: left, behavior: (smooth && !reduce) ? 'smooth' : 'auto' });
      } else {
        rail.scrollLeft = left;
      }
    }

    function syncControls() {
      var count = pages();
      var scrollable = maxScroll() > 1;

      if (dotsBox) {
        if (dots.length !== count) {
          dotsBox.textContent = '';
          dots = [];
          for (var i = 0; i < count; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'kx-ts__dot';
            b.setAttribute('aria-label', 'Quote ' + (i + 1) + ' of ' + count);
            (function (idx) {
              b.addEventListener('click', function () { pause(); goTo(idx, true); });
            })(i);
            dotsBox.appendChild(b);
            dots.push(b);
          }
        }
        dotsBox.hidden = !scrollable;
      }
      if (prev) prev.hidden = !scrollable;
      if (next) next.hidden = !scrollable;
      syncActive();
    }

    function syncActive() {
      var s = stride();
      index = s > 0 ? Math.round(rail.scrollLeft / s) : 0;
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = Math.max(0, dots.length - 1);
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= maxScroll() - 1;
    }

    function advance() {
      var count = pages();
      // Wrapping back to the start jumps rather than scrolls the whole rail
      // backwards past every card, which at speed is a blur of unreadable text.
      var atEnd = rail.scrollLeft >= maxScroll() - 1;
      if (atEnd) goTo(0, false); else goTo(index + 1, true);
      if (count < 2) stop();
    }

    function start() {
      if (reduce || timer || !visible) return;
      if (maxScroll() <= 1) return;
      timer = setInterval(advance, INTERVAL);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    /* Any manual interaction stops the rotation for a while. Auto-advancing
       out from under someone who is reading is the thing that makes carousels
       hostile, so the timer always yields to the reader. */
    function pause() {
      stop();
      if (idle) clearTimeout(idle);
      idle = setTimeout(start, RESUME);
    }

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncActive(); });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { pause(); goTo(index - 1, true); });
    if (next) next.addEventListener('click', function () { pause(); goTo(index + 1, true); });

    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      rail.addEventListener(ev, pause, { passive: true });
    });

    var resizeTick;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTick);
      resizeTick = setTimeout(syncControls, 150);
    });

    // Don't rotate a rail nobody is looking at.
    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.2 }).observe(root);
    }

    syncControls();
    start();
  }

  function setup(root) {
    if (root.getAttribute('data-kx-quotes-mode') === 'spotlight') setupSpotlight(root);
    else setupRail(root);
  }

  function init() {
    document.querySelectorAll('[data-kx-quotes]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-wire when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('[data-kx-quotes]') : []).forEach(setup);
  });
})();
